import React, {useContext, useEffect} from "react"
import {ContainerMap} from "./container-map"
import {DataContext} from "../context/DataContextProvider"
import {ActionContext} from "../context/ActionContextProvider"
import {ContextAreaContext} from "../context/ContextAreaContext"
import {
    checkConditionsForDisabled,
    checkConditionsForHidden,
    checkVisibility,
} from "../../anwendungskonfigurator/misc/precondition-evaluation"
import {getMerkmal} from "../../anwendungskonfigurator/misc/widget-functions"

const Container = ({container, disabled, payload, wrapper}) => {
    const {getDataFromPointer, updateData} = useContext(DataContext)
    const {triggerAction} = useContext(ActionContext)
    const inheritedContextArea = useContext(ContextAreaContext)
    const merkmal = getMerkmal(container)
    const savePointer = merkmal?.pointer
    const value = getDataFromPointer(savePointer)
    const isThisWidgetDisabled = disabled
        ? disabled
        : checkConditionsForDisabled(container, getDataFromPointer)
    const isVisible = checkVisibility(container, getDataFromPointer)
    const hasOwnContextArea = container.contextArea !== undefined
    const ownContextArea = container.contextArea === "none" ? null : container.contextArea
    const effectiveContextArea = hasOwnContextArea
        ? (ownContextArea || null)
        : inheritedContextArea
    const isContextAreaRoot = !!effectiveContextArea && effectiveContextArea !== inheritedContextArea
    const onValueChange = (newValue) => {
        updateData(newValue, savePointer)
    }
    useEffect(() => {
        if (!isContextAreaRoot) return undefined
        triggerAction("GET_CONTEXTAREA", {contextArea: effectiveContextArea, containerId: container.id})
        triggerAction("REGISTER_CONTEXTAREA", {contextArea: effectiveContextArea, containerId: container.id})
        return () => {
            triggerAction("UNREGISTER_CONTEXTAREA", {contextArea: effectiveContextArea})
        }
    }, [isContextAreaRoot, effectiveContextArea])

    try {
        if (!isVisible || checkConditionsForHidden(container, getDataFromPointer)) {
            return <></>
        }
        const content = ContainerMap[container.component]({
            key: container.id,
            container,
            triggerAction,
            value,
            onValueChange,
            getDataFromPointer,
            updateData,
            disabled: isThisWidgetDisabled,
            payload,
            contextArea: effectiveContextArea,
        })
        const scopedContent = hasOwnContextArea
            ? <ContextAreaContext.Provider value={effectiveContextArea}>{content}</ContextAreaContext.Provider>
            : content
        return wrapper ? wrapper(scopedContent) : scopedContent
    } catch (error) {
        console.error(error, container)
        throw new Error(
            "Ein Container hat keine Komponente. Siehe Konsole für Containerinfos.",
        )
    }
}

export default Container
